var map = {
	"./eminent_guest.jpg": 466,
	"./invited_talks.jpg": 5396,
	"./panel_discussion.png": 9568,
	"./pannel_discussion.jpg": 6472,
	"./r&d.jpg": 4925,
	"./r&d_banner.png": 9768,
	"./research_development.png": 3600,
	"./startup.jpg": 4482,
	"./startup.png": 9526
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7313;